import React from "react";

const CarDetail = ({ car }) => (
  <div className="car-detail">
    <img src={car.image} alt={car.model} />
    <h2>{car.model}</h2>
    <p>Price: ${car.price}</p>
    <p>Description: {car.description}</p>
  </div>
);

export default CarDetail;
